import { ComponentProps, forwardRef, ReactNode } from 'react';
import { classNames } from 'src/v2/shared/lib/classNames';
import { Typography } from 'src/v2/shared/ui/Typography';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import styles from './LoadingMessage.module.scss';

type LoadingMessageProps = {
  title: string;
  message: string;
  actions?: ReactNode;
} & ComponentProps<'div'>;

export const LoadingMessage = forwardRef<HTMLDivElement, LoadingMessageProps>(
  ({ title, message, actions, className, ...rest }, ref) => (
    <div className={classNames(styles.container, className)} ref={ref} {...rest}>
      <LoadingSpinner className={styles.spinner} />
      <div className={styles.body}>
        {title && (
          <Typography fontWeight={600} overflow="hidden" textOverflow="ellipsis">
            {title}
          </Typography>
        )}
        {message && (
          <Typography as="p" overflow="hidden" textOverflow="ellipsis">
            {message}
          </Typography>
        )}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
    </div>
  )
);
